// biome-ignore lint/suspicious/noExplicitAny: <explanation>
function withDefer<T extends any[], R>(fn: (defer: (fn: () => void | Promise<void>) => void, ...args: T) => Promise<R>) {
	return async function (...args: T): Promise<R> {
		const deferredFunctions: Array<() => void | Promise<void>> = [];
		const defer = (fn: () => void | Promise<void>) => deferredFunctions.push(fn);

		try {
			return await fn(defer, ...args);
		} finally {
			// Cleanup theo thứ tự LIFO
			while (deferredFunctions.length > 0) {
				const deferredFn = deferredFunctions.pop();
				if (deferredFn) {
					try {
						await deferredFn();
					} catch (error) {
						console.error('Error in deferred function:', error);
					}
				}
			}
		}
	};
}

export default withDefer;
